export default "__VITE_ASSET__5ab8cc58__"